import { render, staticRenderFns } from "./FlowyEntitiesRelationsDatatable.vue?vue&type=template&id=1240ea18"
import script from "./FlowyEntitiesRelationsDatatable.vue?vue&type=script&lang=js"
export * from "./FlowyEntitiesRelationsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports